import { render, staticRenderFns } from "./EventDay.vue?vue&type=template&id=afd47d1e&"
import script from "./EventDay.vue?vue&type=script&lang=js&"
export * from "./EventDay.vue?vue&type=script&lang=js&"
import style0 from "./EventDay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports